export function isFunction<T>(functionToCheck: any): functionToCheck is () => T {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}
